const FLAG = process.env.FLAG;

const config = {
  dev: {
    baseUrl: "http://172.16.10.217:8181",
  }, // 本地
  test: {
    baseUrl: "http://www.timesnew.cn:8181",
  }, // 测试
  pro: {
    baseUrl: "http://www.timesnew.cn",
  }, // 生产
};

module.exports = config[FLAG];
